<template>
  <div class="code">
    <div>
      SNITCH_ID=<span class="has-text-white">{{ keys.SNITCH_ID }}</span>
    </div>
    <div>
      SNITCH_SECRET=<span class="has-text-white">{{ keys.SNITCH_SECRET }}</span>
    </div>
    <div>
      SNITCH_KEY=<span class="has-text-white">{{ keys.SNITCH_KEY }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    keys: {
      type: Object,
      default: () => ({
        SNITCH_ID: '',
        SNITCH_KEY: '',
        SNITCH_SECRET: '',
      })
    }
  }
}
</script>
